export const setStateCheckHideRows = (ischecked=false) => {
    return {
        type : 'SET_STATE_CHECK_HIDE_ROWS',
        payload : ischecked
    }
}